<!-- Trigger area (icon) -->
<div
  class="ui-selector-item ui-clickable flex-row start-center"
  (click)="toggleDropdown()"
  role="button"
  tabindex="0"
  aria-haspopup="true"
  #triggerElement
>
  <ng-content select="[input]"></ng-content>
</div>

<!-- Visible dropdown panel -->
<div
  *ngIf="isOpen"
  #dropdownPanel
  class="content-wrapper ui-selector-panel"
  [style.max-height.px]="height"
  [style.left.px]="dropdownPosition.left"
  [style.top.px]="dropdownPosition.top"
  role="menu"
  tabindex="0"
>
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</div>

<!-- Hidden off-screen measurement (optional) -->
<div
  #hiddenContainer
  class="ui-selector-panel"
  style="position: absolute; left: -9999px; visibility: hidden;"
>
  <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
</div>
